<template>
	<div class="page">
		<!-- 页面路径 -->
		<div class="pageRouter f-ct">
			当前位置：<span>首页</span>
			<el-image :src="require('@/static/icon23.png')"></el-image>
			<span class="blue">培训教育</span>
		</div>
		<!-- 筛选 -->
		<div class="shaixuan animate__animated animate__fadeIn" data-wow-duration="0.8s">
			<div class="catBox" style="padding-bottom: 0.1rem;">
				<div class="cat flex" style="flex-wrap: nowrap;margin-bottom: 0.1rem;">
					<div class="tit" style="padding-top: 0.04rem;">方向:</div>
					<div class="f-ct" style="width: calc(100% - 1rem);">
						<div class="itm" style="margin-bottom: 0.1rem;" @click="selCat(itm)" :class="catIdx==itm.id?'a':''" v-for="(itm,idx) in catArr">{{itm.categoryName}}</div>
					</div>
				</div>
				<div class="cat flex" style="flex-wrap: nowrap;margin-bottom: 0rem;">
					<div class="tit" style="padding-top: 0.04rem;">分类:</div>
					<div class="f-ct" style="width: calc(100% - 1rem);">
						<div class="itm" style="margin-bottom: 0.1rem;" @click="selCat1(itm.id)" :class="catIdx1==itm.id?'a':''" v-for="(itm,idx) in catArr1">{{itm.categoryName}}</div>
					</div>
				</div>
			</div>
			<div class="seach f-ct">
				<div class="iptBox f-ct">
					<!-- <div class="sel">
						<el-select v-model="value" placeholder="请选择">
							<el-option
								v-for="item in options"
								:key="item.value"
								:label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
					<div class="bor"></div> -->
					<div class="ipt">
						<el-input type="text" v-model="keyword" placeholder="请输入搜索关键词"></el-input>
					</div>
				</div>
				<div class="seachBtn f-ct">
					<div @click="pageNum=1,courselist()">搜索</div>
					<div @click="keyword='',pageNum=1,courselist()">重置</div>
				</div>
			</div>
		</div>
		<!-- 表格 -->
		<div class="biaoge animate__animated animate__fadeIn" data-wow-duration="0.8s">
			
			<div class="table">
				<div class="th f-ct">
					<p class="t1">序号</p>
					<p class="t2">课程名称</p>
					<p class="t3">课程类型</p>
					<!-- <p class="t4">收费标准</p> -->
					<p class="t5">学时</p>
					<p class="t6">发布日期</p>
				</div>
				<div class="zw" v-if="!msgList.length">
					<el-image :src="require('@/static/zw.png')"></el-image>
					<p>暂无相关数据...</p>
				</div>
				<div class="td f-ct" @click="goMsg(item)" v-for="(item,index) in msgList">
					<p class="t1">{{index*1+1}}</p>
					<div class="t2">
						<span>{{item.name}}</span>
						<el-image v-if="item.isHot" :src="require('@/static/icon20.png')"></el-image>
					</div>
					<p class="t3">{{item.categoryName}}</p>
					<!-- <p class="t4">￥{{item.price}}</p> -->
					<p class="t5">{{item.studyHours}}</p>
					<p class="t6">{{quSFM(item.createTime)}}</p>
				</div>
			</div>
			<div class="fenye">
			<el-pagination
			background
			hide-on-single-page
			layout="prev, pager, next,jumper"
			@current-change="goPage"
			:page-size="pageSize"
			:total="total">
			</el-pagination>
			</div>	
			<!-- <div class="fenye">
				<el-image class="i1" :src="require('@/static/icon24.png')"></el-image>
				<div class="fyitm a">1</div>
				<div class="fyitm">2</div>
				<div class="fyitm">...</div>
				<div class="fyitm">3</div>
				<el-image class="i2" :src="require('@/static/icon25.png')"></el-image>
				<div class="linkPage f-ct">
					<p>跳转</p>
					<div class="ipt">
						<el-input type="text" v-model="mobile"></el-input>
					</div>
					<p>至</p>
				</div>
			</div> -->
		</div>
	</div>
</template>
<script>
import { coursecategoryList,courselist,coursedetail } from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	data(){
		return {
			catArr:[],
			catArr1:[],
			catIdx:0,
			catIdx1:0,
			keyword:'',
			// 分页
			pageNum:1,
			pageSize:10,
			total:0,
			// 列表
			msgList:[],
			allChildCategoryList:[],
		}
	},
	mounted() {
		this.coursecategoryList()
		this.courselist()
	},
	methods:{
		goMsg(item){
			if(this.userInfo){
				this.link('/userCourseMsg',{id:item.id})
			}else{
				this.Tips('请先登录','error')
				setTimeout(()=>{
					this.link('/login')
				},1500)
			}
		},
		// 选择分类
		selCat(item){
			this.catIdx = item.id
			this.catArr1 = item.childList
			this.catIdx1 = item.childList[0].id
			this.pageNum = 1
			this.courselist()
		},
		// 选择分类
		selCat1(id){
			this.catIdx1 = id
			this.pageNum = 1
			this.courselist()
		},
		// 分类列表
		async coursecategoryList(){
			let res = await coursecategoryList({});
			if(res.code==200){
				var catIdx = []
				res.data.categoryList.forEach((item)=>{
					item.childList = [{
						id:item.id,
						categoryName:'全部',
					},...item.childList]
				})
				this.catArr = [{
					id:0,
					categoryName:'全部',
					childList:[{
						id:0,
						categoryName:'全部'
					},...res.data.allChildCategoryList],
				},...res.data.categoryList]
				this.catArr1 = this.catArr[0].childList
			}else{this.Tips(res.msg,'error')}
		},
		// 查询课程列表
		async courselist(){
			var data = {
				pageSize: this.pageSize,
				pageNum: this.pageNum,
				orderByColumn:'id',
				isAsc:'desc'
			}
			if(this.catIdx1){
				data.categoryId = this.catIdx1
			}
			if(this.keyword){
				data.name = this.keyword
			}
			let res = await courselist(data);
			if(res.code==200){
				if(this.pageNum==1){
					this.total = res.total
				}
				this.msgList = res.rows
			}else{this.Tips(res.msg,'error')}
		},
		// 跳转页
		goPage(e){
			// console.log(e)
			this.pageNum = e
			this.courselist()
		},
	},
	computed:{
		...mapState('userMsg',['userInfo']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.page{
	width: 1200px;
	margin: auto;
	padding-bottom: 20px;
}
.pageRouter{
	padding: 24px 0;
	font-size: 16px;
	span{
		color: #666666;
	}
	.el-image{
		width: 16px;
		height: 16px;
		margin: 0 3px;
	}
	.blue{
		color: #3B6492;
	}
}
.shaixuan{
	width: 100%;
	padding: 0 24px;
	background: #fff;
	.catBox{
		padding: 24px 0;
		border-bottom: 1px solid #EEEEEE;
	}
	.cat{
		margin-bottom: 20px;
		&:last-child{
			margin-bottom: 0;
		}
		.tit{
			font-size: 14px;
			color: #333333;
		}
		.itm{
			margin-left: 18px;
			height: 28px;
			line-height: 28px;
			padding: 0 8px;
			border-radius: 4px;
			font-size: 14px;
			color: #545964;
			cursor: pointer;
		}
		.a{
			background: #E9F6FF;
			color: #3B6492;
			cursor: pointer;
		}
	}
	.seach{
		width: 100%;
		height: 70px;
		background: #fff;
		padding: 15px 0px;
		.iptBox{
			width: 956px;
			height: 40px;
			border: 1px solid #DDDDDD;
			margin-right: 12px;
			.sel{
				.el-select{
					width: 97px;
				}
				::v-deep .el-input__inner{
					border: none;
					background: transparent;
					font-size: 14px;
				}
			}
			.bor{
				width: 1px;
				height: 20px;
				background: #DDDDDD;
			}
			.ipt{
				width: calc(100% - 100px);
				.el-select{
					width: 100%;
				}
				::v-deep .el-input__inner{
					border: none;
					background: transparent;
				}
			}
		}
		.seachBtn{
			div{
				width: 85px;
				height: 40px;
				border: 1px solid #DDDDDD;
				font-size: 16px;
				color: #666666;
				text-align: center;
				line-height: 38px;
				cursor: pointer;
				&:first-child{
					background: #3B6492;
					border: 1px solid #3B6492;
					color: #fff;
					margin-right: 12px;
				}
			}
		}
	}
}
.biaoge{
	padding: 24px;
	background: #fff;
	margin-top: 24px;
	.table{
		border: 1px solid #EBEEF5;
		.th{
			height: 40px;
			background: linear-gradient(180deg, #F8F9FE 0%, #EDEFF6 81.25%);
			p{
				line-height: 40px;
				text-align: center;
				font-size: 14px;
				color: #333333;
			}
			.t1{
				width: 80px;
			}
			.t2{
				width: 438px;
				padding-left: 14px;
				text-align: left;
			}
			.t3{
				width: 280px;
			}
			.t4{
				// width: 140px;
			}
			.t5{
				width: 110px;
			}
			.t6{
				width: 227px;
			}
		}
		.td{
			border-bottom: 1px solid #EBEEF5;
			align-items: stretch;
			>p{
				line-height: 40px;
				text-align: center;
				font-size: 14px;
				color: #333333;
				border-right: 1px solid #EBEEF5;
				padding: 0 10px;
			}
			.t1{
				width: 80px;
			}
			.t2{
				width: 448px;
				padding-left: 14px;
				text-align: left;
				border-right: 1px solid #EBEEF5;
				line-height: 40px;
				span{
					font-size: 13px;
				}
				.el-image{
					width: 15px;
					height: 18px;
					margin-left: 2px;
					transform: translateY(2px);
				}
			}
			.t3{
				width: 280px;
			}
			.t4{
				width: 140px;
				color: #FF5F5A;
			}
			.t5{
				width: 110px;
			}
			.t6{
				width: 227px;
				border: none;
			}
		}
	}
	.fenye{
		display: flex;
		align-items: center;
		justify-content: flex-end;
		margin-top: 26px;
		.i1{
			width: 24px;
			height: 24px;
			margin-right: 6px;
		}
		.fyitm{
			width: 32px;
			height: 32px;
			font-size: 12px;
			text-align: center;
			line-height: 32px;
			margin-right: 6px;
			border-radius: 4px;
		}
		.a{
			background: #3B6492;
			color: #fff;
		}
		.i2{
			width: 24px;
			height: 24px;
			margin-right: 19px;
		}
		.linkPage{
			p{
				font-size: 12px;
			}
			.ipt{
				margin: 0 6px;
				width: 42px;
				height: 32px;
				border-radius: 4px;
				background: #F4F4F4;
				.el-select{
					width: 100%;
				}
				::v-deep .el-input__inner{
					border: none;
					background: transparent;
				}
			}
		}
	}
}
</style>